module.exports = __webpack_public_path__ + "img/james-islington.eb8d1380.png";